import React from 'react';
import { connect } from 'react-redux';

import * as fieldsActions from '../../common/redux/actions/fieldsActions';

/*
  Подключает данные из state.Common.Filters, если их там нет, вызовет action
  filterConnect(Component,['weekDays', 'serviceTypes', 'regions']);
*/
//TEST соmment
//TEST соmment

const filterConnect = (Component, filters) => {
  return connect(
    (state) => {
      if (Array.isArray(filters)) {
        return filters.reduce((obj, item) => {
          return {
            ...obj,
            [item]: state.Common.Filters[item],
          };
        }, {});
      }
    },
    (dispatch) => ({
      getFilterAction: (filters, props) => {
        if (Array.isArray(filters)) {
          filters.forEach((name) => {
            if (!props[name]) {
              let actionName = 'get' + name[0].toUpperCase() + name.slice(1);
              if (typeof fieldsActions[actionName] === 'function') {
                dispatch(fieldsActions[actionName]());
              }
            }
          });
        }
      },
    })
  )(
    class extends React.Component {
      componentDidMount() {
        this.props.getFilterAction(filters, this.props);
      }
      render() {
        return <Component {...this.props} />;
      }
    }
  );
};

export default filterConnect;
